import { createSelector } from '@reduxjs/toolkit';

import { selectCommercialPriceType, selectIsSquareMeterPrice } from 'shared/selectors/jsonQuery';

import { EJsonQueryPriceType } from '../../../../packages/api-models/common/json_query';
import { EPriceType } from '../../../../packages/JsonQuery';

export const selectCommercialPriceTypeValue = createSelector(
  [selectIsSquareMeterPrice, selectCommercialPriceType],
  (isSquareMeterPrice, commercialPriceType) => {
    if (commercialPriceType === EJsonQueryPriceType.Workplace) {
      return EPriceType.SM;
    }

    return isSquareMeterPrice ? EPriceType.SM : EPriceType.Total;
  },
);
